import RichTextRenderer from "components/UI/RichTextRenderer"
import { GatsbyImage } from "gatsby-plugin-image"
import { getLuminance } from "polished"
import React from "react"
import styled from "styled-components"
import getGatsbyImage from "utils/getGatsbyImage"
import { FONT_FAMILIES } from "../../../styles/Theme"

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  color: ${(props: { textColor: string }) => props.textColor};
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: ${(props: { bgColor?: string }) => props.bgColor};
  z-index: -1;
  > :first-child {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
`

const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1100px;
  padding: 0 20px;
  line-height: 27px;
  a {
    text-decoration: underline;
  }
  > h1,
  h2,
  h3,
  h4,
  h5 {
    ${FONT_FAMILIES.rammetto};
  }
  img {
    margin: 20px auto;
    display: block;
    max-width: 1020px;
    max-height: 600px;
  }
  li {
    margin-bottom: 18px;
  }
`

interface IProps {
  content: any
  bgColor: string
  bgImage: any
}

const RichSection = (props: IProps) => {
  const { content, bgImage, bgColor } = props

  const textColor =
    bgColor && bgColor !== "" && getLuminance(bgColor) > 0.5 ? "#000" : "#fff"

  return (
    <Wrapper textColor={textColor}>
      {bgImage && (
        <Overlay>
          <GatsbyImage
            image={getGatsbyImage(bgImage.localFile)}
            alt="Free Resources"
          />
        </Overlay>
      )}
      {bgColor && (
        <Overlay bgColor={bgColor}>
          <div />
        </Overlay>
      )}
      <Content>
        <RichTextRenderer>{content}</RichTextRenderer>
      </Content>
    </Wrapper>
  )
}

export default RichSection
